// src/components/Footer.js
import React from 'react';
import { Button } from 'react-bootstrap';
import { HeartFill } from 'react-bootstrap-icons';
import { useTranslation } from 'react-i18next';
import { openCapacitorSite } from '../../utils/browserUtils';
import './Footer.css';

const Footer = () => {
  const { t } = useTranslation('common');
  return (
    <footer className="app-footer">
      <h5 id='headingSelectHomeCountry'>
        {t('common:supportFoundation', 'Support the Gov Glance Foundation')}
        <Button 
          id='donateButton' 
          onClick={(e) => {
            e.preventDefault();
            openCapacitorSite('https://donate.stripe.com/28o3fXbdvbQO2RO288');
          }}
        >
          <HeartFill id='donateIcon' /> {t('common:donate', 'Donate')}
        </Button>
      </h5>
    </footer>
  );
};

export default Footer;